export default __webpack_public_path__ + "static/media/NW0120.34I-35463_-20499_0.b830281e.jpg";